module.exports = __webpack_public_path__ + "fonts/Averta-Bold.f0bf846.otf";